const messages = {
  name: 'Tarea Programada |||| Tareas Programadas',
  fields: {
    scheduleId: 'ID de Programacion',
    nextExecution: 'Proxima Ejecucion',
    status: 'Estado',
    notification: 'Notificacion',
    actions: 'Acciones',
  },
  filters: {
    account: 'Cuenta',
    application: 'Aplicacion',
    group: 'Grupo',
    all: 'Todos',
  },
  actions: {
    viewDetails: 'Ver Detalles',
    reschedule: 'Reprogramar',
    pause: 'Pausar',
    resume: 'Reanudar',
    delete: 'Eliminar',
  },
  dialog: {
    notificationDetails: 'Detalles de la Notificacion',
  },
  deleteDialog: {
    title: 'Eliminar la programacion %{id}?',
    content: 'Se cancela el envio programado. Esta accion no se puede deshacer.',
  },
  rescheduleDialog: {
    title: 'Reprogramar envio',
    datetime: 'Nueva fecha y hora',
  },
  notifications: {
    deleted: 'Programacion eliminada.',
    paused: 'Programacion pausada.',
    resumed: 'Programacion reanudada.',
    rescheduled: 'Programacion actualizada.',
    loadAccountsFailed: 'Error al cargar las cuentas',
  },
};

export default messages;
